import config from '../core/config';
import service from '../core/service';
import dimension from '../core/dimensions';
import cookie from '../helpers/cookie';
import helper from '../helpers/generic';

function createCustomDimensions() {

  if (!dimension.exist()) {
    dimension.setRegistrado('no');
    dimension.setSuscriptorType('N/A');
    dimension.setUserId('');
    dimension.save();
  }


  let CD = dimension.get();
  let withToken = helper.isEmpty(cookie.read('token'));
  let usuarioLogeado = withToken ? 'no' : 'yes';
  let payUser = helper.isEmpty(cookie.read('ProductoPremiumId')) ? 'no' : 'yes';
  let userId = cookie.read('usuario%5Fid');
  let clubLN = cookie.read('usuarioDetalleClubNacion');
  let notasLeidas = cookie.read('countNotas');

  if (!window.dataLayer) {
    window.dataLayer = [{}];
  }

  dataLayer[0].notasLeidas = notasLeidas ? notasLeidas : 0;
  dataLayer[0].usuarioLogeado = usuarioLogeado;
  dataLayer[0].usuarioRegistrado = CD.usuarioRegistrado;
  dataLayer[0].payUser = payUser;
  dataLayer[0].suscriptorType = CD.suscriptorType;
  dataLayer[0].userId = CD.userId;
  dataLayer[0].credentialType = clubLN ? clubLN : 'N/A';
}

function setupUserCookies(user) {
  let cookiekey = '',
    cookievalue = '';

  Object.keys(user).forEach(key => {

    if (config.cookies.filter(current => { if (current == key) return current; })[0]) {
      switch (key) {
        case 'UsuarioDetalleGuid':
          cookiekey = "usuario%5Fdetalle%5Fguid";
          cookievalue = '{' + cookie.read('token') + '}';
          break;
        case 'UsuarioDetalleNick':
          cookiekey = "usuario%5Fdetalle%5Fnick";
          cookievalue = user[key];
          break;
        case 'UsuarioId':
          cookiekey = "usuario%5Fid";
          cookievalue = user[key];
          break;
        case 'UsuarioUsuario':
          cookiekey = "usuario%5Fusuario";
          cookievalue = user[key];
          break;
        case 'usuarioLogTkn':
          cookiekey = "usuario%5Flogtkn";
          cookievalue = user[key];
          break;
        case 'TokenJWT':
          cookiekey = "PersoTKN";
          cookievalue = user[key];
          break;
        default:
          cookiekey = key;
          cookievalue = user[key];
      }

      cookie.write(cookiekey, cookievalue);
    }
  });
}

module.exports = {
  //manageUserGoogleAccount: function (id, token, firstname, lastname, email) {
  //    return manageGoogleAccount(id, token, firstname, lastname, email);
  //},
  isLogedIn: function () {
    let withToken = helper.isEmpty(cookie.read('token'));
    return withToken ? false : true;
  },

  getGoogle: () => {
    return service.get('https://www.google.com', null, null);
  },

  manageSocialNetwork: (id, token, firstname, lastname, email, authentication) => {
    if (!authentication) {
      authentication = {
        'X-Token': cookie.read('token'),
        'X-Value': cookie.read('xvalue')
      };
    }
    let Usuario = {
      UsuarioGmailId: id,
      UsuarioDetalleNombre: firstname,
      UsuarioDetalleApellido: lastname,
      GMail: email,
      AccessToken: token,
      GGivenName: firstname,
      GFamilyName: lastname,
      SitioId: config.SitioId
    };

    // Retrieve access token.
    return service.post(config.api.login + '/Usuario/SWGLogin', Usuario, authentication);
  },

  tokenLogin: (token) => {
    // Retrieve access token.
    return service.post(config.api.login + '/Usuario/TokenLogin', token, null);
  },

  requestUserMe: (authentication) => {
    if (!authentication) {
      authentication = {
        'X-Token': cookie.read('token'),
        'X-Value': cookie.read('xvalue')
      };
    }

    return service.post(
      config.api.login + '/Usuario/Me',
      {},
      authentication
    ).then((data) => {
      let response = JSON.parse(data.response);
      response.Usuario.token = authentication['X-Token'];
      response.Usuario.xvalue = authentication['X-Value'];

      setupUserCookies(response.Usuario);
    });
  },

  getUserAnalyticsSubscription: (userid, authentication) => {
    if (!authentication) {
      authentication = {
        'X-Token': cookie.read('token'),
        'X-Value': cookie.read('xvalue')
      };
    }

    return service.post(
      config.api.paywall + '/1/SuscripcionV1/ObtenerSuscripcionDigitalAnalytics',
      {},
      authentication
    ).then((data) => {

      dimension.setUserId(userid);
      dimension.save();
      dimension.setRegistrado('yes');
      dimension.save();
      dimension.setSuscriptorType(data.response.nombre || 'N/A');
      dimension.save();

      createCustomDimensions();
    })
    .catch((e) => {
      console.log(e);
    });
  },

  saveGoogleUserPurchase: (data, authentication) => {
    if (!authentication) {
      authentication = {
        'X-Token': cookie.read('token'),
        'X-Value': cookie.read('xvalue')
      };
    }

    let model = {     
      sku: JSON.parse(data.purchaseData.raw).productId,
      planId: 4028,
      campaniaId: 409,
      //idCanalDeVenta: '',
      //idFormaDeContacto: '',
      idOrigen: parseInt(config.SitioId),
      SitioOrigen: config.SitioId,
      esVentaSWG: true,
      purchaseDataSWG: data.purchaseData.raw,
      clienteModel: {
        nombre: data.userData.givenName,
        apellido: data.userData.familyName,
        tipoDocumento: 'GoogleId',
        numeroDocumento: data.userData.email,
        telefonoParticular: '0',
        email: data.userData.email
      },
      domicilioModel: {}
    };

    return service.post(
      config.api.paywall + '/Venta/GuardarVentaSWG',
      model,
      authentication
    );
  },

  checkIfUserExists: (source, token) => {
    let model = {
      Source: source,
      Data: token
    }

    return service.post(
      config.api.paywall + '/Cliente/UserExistsFromPurchaseToken',
      model,
      {}
    );
  },
  forceSWGLogout: () => {
    cookie.write(config.swgPreventLoginCookie, true);
  },
  isSWGLoginEnable: () => {
    return !cookie.read(config.swgPreventLoginCookie);
  }
}


// WEBPACK FOOTER //
// ./~/@ln/registracionlibs/src/controllers/user.js